import { Component, Input } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "komponent",
    templateUrl: "./komponent.component.html",
    styleUrls: ["./komponent.component.scss"]
})
export class KomponentComponent {
    @Input() public formGroup: UntypedFormGroup;

    public get dimensioner(): UntypedFormArray {
        return this.formGroup.get("dimensioner") as UntypedFormArray;
    }
}
